import { useState, useEffect, useCallback } from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import axiosInstance from "../../../api/axios";
import dayjs from 'dayjs';
import Table from "./Table";
import { notifyError, notifySuccess } from "../../../components/common/toast/ToastFunc";

const Transactions = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const [reFetch, setReFetch] = useState(false);
  const [transactionType, setTransactionType] = useState("All");

  const theme = useTheme();

  const formatData = useCallback((data) => {
    try {

      const formattedData = data.map(item => {
        return {
          ...item,
          id: item?.id.replace(/-/g, ""),
          from_acc: item.from_acc.replace(/-/g, ''),
          to_acc: item.to_acc.replace(/-/g, ''),
          amount: `$ ${item.amount}`,
          created_at: dayjs(item.created_at).format('MM/DD/YYYY HH:mm:ss'),
          status: item?.status.charAt(0).toUpperCase() + item?.status.slice(1).toLowerCase(),
          type: item?.type.charAt(0).toUpperCase() + item?.type.slice(1).toLowerCase()
        };
      });
      setData(formattedData);
    } catch (error) {
      notifyError("Something went wrong.");
    }
  }, []);

  const authorizeTransaction = useCallback(async (transaction_id) => {
    setActionLoading(true);
    try {
      const response = await axiosInstance.post('/auth/authorize-profile-transaction', { id: transaction_id, auth_type: "Transaction" });
      notifySuccess(response?.data?.message || "Success");
      setReFetch(!reFetch);
    } catch (error) {
      notifyError(error.message || "Something went wrong");
    } finally {
      setActionLoading(false);
    }
  }, [reFetch, setActionLoading, setReFetch]);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get('/transaction/get-all', {
          params: {
            status: transactionType,
          }
        });
        formatData(response.data.data);
        setLoading(false);
      } catch (error) {
        notifyError(error.message || "Something went wrong");
      }
      setLoading(false);
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reFetch, transactionType]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", my: 3 }}>
      <Typography variant="h5" sx={{ mb: 2, color: theme.mainColor }}>Transactions</Typography>
      <Table
        data={data}
        setData={setData}
        loading={loading}
        actionLoading={actionLoading}
        setReFetch={setReFetch}
        transactionType={transactionType}
        setTransactionType={setTransactionType}
        authorizeTransaction={authorizeTransaction}
      />
    </Box>
  );
};

export default Transactions;
